import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { createPopper } from '@popperjs/core';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TOOGLE_PROFILE, EMPTYSOTRE } from 'reactStore/actions/Actions';

const IndexDropdown = () => {
  let navigate = useNavigate();

  const { IsCognito, currentName, currentPic, profile } = useSelector(
    (state) => state.User
  );

  const dispatch = useDispatch();
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const wrapperRef = useRef(null);

  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: 'bottom-start',
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  return (
    <>
      <button
        className='hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'
        ref={btnDropdownRef}
        onClick={(e) => {
          // e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <img
          id='output'
          src={currentPic}
          className='w-10 h-10 rounded-full object-cover'
          alt=''
        />
      </button>
      <div
        ref={popoverDropdownRef}
        onBlur={closeDropdownPopover}
        onMouseLeave={closeDropdownPopover}
        className={
          (dropdownPopoverShow ? 'block ' : 'hidden ') +
          'bg-white text-xs z-50 py-2 list-none  text-left rounded shadow-lg min-w-96'
        }
      >
        <button
          onClick={() => {
            if (IsCognito) {
              let data = {
                IsCognito: false,

                currentName: profile.fname,
                currentPic: profile.pic,
              };

              dispatch(TOOGLE_PROFILE(data));
            } else {
              let data = {
                IsCognito: true,

                currentName: 'Inkognitomodus',
                currentPic:
                  'https://media.istockphoto.com/photos/hooded-incognito-silhouette-isolated-and-hacker-on-black-background-picture-id1282969367?b=1&k=20&m=1282969367&s=170667a&w=0&h=xIyAeDd_STG9Iw6b_M-1xmVliEROHfvoSd-CsND_-3Q=',
              };

              dispatch(TOOGLE_PROFILE(data));
            }
          }}
          className='flex  py-4 px-4 font-normal hover:bg-color-light-yellow w-full whitespace-nowrap bg-transparent text-blueGray-700'
        >
          <img
            id='output'
            src={currentPic}
            className='w-10 h-10 rounded-full object-cover'
            alt=''
          />
          <span className='text-xs m-2 font-semibold'> {currentName} </span>
        </button>
        <button className='text-xs py-2 px-4 font-normal block hover:bg-color-light-yellow  w-full whitespace-nowrap bg-transparent text-blueGray-700'>
          Profil | Einstellungen
        </button>
        <button
          onClick={() => {
            dispatch(EMPTYSOTRE());

            navigate('/');
          }}
          className='text-xs py-2  font-normal block hover:bg-color-light-yellow  w-full whitespace-nowrap bg-transparent text-blueGray-700'
        >
          Ausloggen
        </button>
      </div>
    </>
  );
};

export default IndexDropdown;
